import { isRoleCatalogDetailResponse, isRoleCatalogListResponse, } from '@urbanik/api-contracts';
export class RoleCatalogApiError extends Error {
    kind;
    constructor(kind, message) {
        super(message);
        this.kind = kind;
        this.name = 'RoleCatalogApiError';
    }
}
async function request(url, init) {
    try {
        return await fetch(url, { ...init, credentials: 'include' });
    }
    catch {
        throw new RoleCatalogApiError('unavailable', 'No pudimos conectar con el servidor.');
    }
}
async function problem(response) {
    const payload = (await response.json().catch(() => null));
    const message = payload?.message ?? 'No pudimos completar la operación.';
    if (response.status === 401)
        throw new RoleCatalogApiError('unauthorized', message);
    if (response.status === 403)
        throw new RoleCatalogApiError('forbidden', message);
    if (response.status === 409)
        throw new RoleCatalogApiError('conflict', message);
    if (response.status === 400)
        throw new RoleCatalogApiError('validation', message);
    throw new RoleCatalogApiError('unavailable', message);
}
export async function getRoleCatalog(baseUrl, options, signal) {
    const params = new URLSearchParams({
        page: String(options.page ?? 1),
        pageSize: String(options.pageSize ?? 10),
    });
    if (options.search)
        params.set('search', options.search);
    if (options.active !== 'all' && options.active !== undefined)
        params.set('active', String(options.active));
    const response = await request(`${baseUrl.replace(/\/$/, '')}/identity/admin/roles?${params}`, {
        headers: { Accept: 'application/json' },
        signal: signal ?? null,
    });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isRoleCatalogListResponse(payload))
        throw new RoleCatalogApiError('unavailable', 'El catálogo de roles no es válido.');
    return payload;
}
async function mutation(baseUrl, path, method, input) {
    const response = await request(`${baseUrl.replace(/\/$/, '')}${path}`, {
        method,
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(input),
    });
    if (!response.ok)
        return problem(response);
    const payload = await response.json();
    if (!isRoleCatalogDetailResponse(payload))
        throw new RoleCatalogApiError('unavailable', 'El rol recibido no es válido.');
    return payload;
}
export const createRole = (baseUrl, input) => mutation(baseUrl, '/identity/admin/roles', 'POST', input);
export const updateRole = (baseUrl, roleId, input) => mutation(baseUrl, `/identity/admin/roles/${encodeURIComponent(roleId)}`, 'PATCH', input);
export const changeRoleStatus = (baseUrl, roleId, input) => mutation(baseUrl, `/identity/admin/roles/${encodeURIComponent(roleId)}/status`, 'PATCH', input);
